import { AnimatePresence, motion } from 'framer-motion';
import React, { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { ShouldRender } from '@/components/shared/basic/ShouldRender';
interface Props {
  title: number | string;
  icon?: ReactNode;
  className?: string;
}
const MenuButton: FC<Props> = ({ title, icon, className }) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
      >
        <button
          className={twMerge(
            'ps-3 pe-[14px] xl:h-[40px] h-[32px] rounded-full bg-grayZl-900 flex items-center gap-1 transition-all hover:bg-grayZl-800 hover:scale-105 active:scale-95',
            className,
          )}
        >
          <ShouldRender check={icon}>{icon}</ShouldRender>
          <p className='text-sm/[22px] text-grayZl-25 font-medium '>{title}</p>
        </button>
      </motion.div>
    </AnimatePresence>
  );
};

export default MenuButton;
